document.addEventListener('DOMContentLoaded', () => {

  
  if (document.body.hasAttribute('index')) {
    headerLigtDark();

    scrollSnap2ndSection();
    // console.log('index');
  }
  
  headerBottomPosition();

  scrolledPastHero();
  
  handleSubmenuDrawer();

  const removeDelay = 500;
  function handleSubmenuDrawer() {
    const menuItems = document.querySelectorAll('.header__menu-item');
    
    menuItems.forEach(item => {
      item.addEventListener('click', () => {
        setTimeout(() => {
          const hasActiveSubmenu = document.querySelector('.submenu.active') !== null || 
                                  document.querySelector('.submenu-right.active') !== null;
          
          if (hasActiveSubmenu) {
            document.documentElement.classList.add('drawer_open');
          } else {
            setTimeout(() => {
              document.documentElement.classList.remove('drawer_open');
            }, removeDelay); // Delay when removing the class
          }
        }, 10); // Small timeout to ensure submenu state has updated
      });
    });
    
    // Handle clicks outside the submenu to remove the drawer_open class
    document.addEventListener('click', (event) => {
      if (!event.target.closest('.header__menu-item') && 
          !event.target.closest('.submenu') && 
          !event.target.closest('.submenu-right') && 
          !event.target.closest('.header__search') &&
          !event.target.closest('header-drawer')) {
        setTimeout(() => {
          document.documentElement.classList.remove('drawer_open');
        }, removeDelay);
      }
    });
  }

  function scrolledPastHero() {
    const firstSection = document.querySelectorAll('.section')[0];
    const sectionHeader = document.querySelector('.section-header');
  
    if (firstSection && sectionHeader) {
      const stickyOffset = firstSection.offsetTop; // Distance of the first section from the top of the document
      const sectionHeight = firstSection.offsetHeight; // Full height of the first section
  
      window.addEventListener('scroll', function () {
        const scrollY = window.scrollY;
  
        // Check if the scroll position is beyond the section's height + its offset
        if (scrollY > stickyOffset + sectionHeight) {
          sectionHeader.classList.add('scrolled-past-hero');
          console.log('First section has been fully scrolled past');
        } else {
          sectionHeader.classList.remove('scrolled-past-hero');
        }
      });
    }
  }
    
  function headerBottomPosition() {
    // Set the custom property for header's bottom position
    document.body.style.setProperty(
      '--header-bottom-position',
      `${parseInt(document.querySelector('header').offsetHeight)}px`
    );
  
    // Add an event listener for resize event
    window.addEventListener('resize', function onResize() {
      document.body.style.setProperty(
        '--header-bottom-position',
        `${parseInt(document.querySelector('header').offsetHeight)}px`
      );
    });
  }
  
  function headerLigtDark(){
    // Get references to the header and the second section
    const header = document.querySelector('.header-light');
    const secondSection = document.querySelectorAll('.section')[1];
    const offset = 50; // Adjust this value for your desired offset
    // Listen for the scroll event
    window.addEventListener('scroll', () => {
      // Get the position of the second section relative to the viewport
      const rect = secondSection.getBoundingClientRect();
    
      // If the second section reaches the top of the viewport
      if (rect.top <= offset) {
        header.classList.remove('header-light');
        header.classList.add('header-dark');
        header.classList.add('section-snapped');
      } else {
        header.classList.remove('header-dark');
        header.classList.add('header-light');
      }
    });
  } 
    
  function scrollSnap2ndSection() {
    // Ease-out cubic function for smooth deceleration
    function easeOutQuad(t) {
      return t * (2 - t);
    }
  
    function smoothScrollTo(targetY, duration) {
      const startY = window.scrollY;
      const change = targetY - startY;
      const startTime = performance.now();
  
      function scroll() {
        const currentTime = performance.now() - startTime;
        const progress = currentTime / duration;
        const easedProgress = easeOutQuad(progress);
  
        window.scrollTo(0, startY + change * easedProgress);
  
        if (currentTime < duration) {
          requestAnimationFrame(scroll);
        } else {
          window.scrollTo(0, targetY); // Ensure it reaches exactly the target (snapping)
        }
      }
  
      requestAnimationFrame(scroll);
    }
  
    // Only activate smooth scrolling on desktop
    function isDesktop() {
      return window.innerWidth >= 1024; // Consider desktop screen widths to be 1024px or more
    }
  
    let hasScrolled = false;
    let scrollTimeout;
  
    document.addEventListener('scroll', function() {
      if (!isDesktop()) return; // Skip if not on desktop
  
      if (scrollTimeout) {
        clearTimeout(scrollTimeout); // Clear any previous timeout for scroll reset
      }
  
      if (!hasScrolled && window.scrollY > 10) { // Scroll down trigger
        hasScrolled = true;
        smoothScrollTo(document.querySelector('.section:nth-child(2)').offsetTop, 1000); // Scroll to second section
      }
  
      // Timeout to handle the scroll back to top
      scrollTimeout = setTimeout(function() {
        if (window.scrollY < 10 && hasScrolled) { // Scroll back to top trigger
          hasScrolled = false;
          smoothScrollTo(0, 1000); // Scroll back to top
        }
      }, 50); // Small delay to detect scroll direction change
    });
  }

});


jQuery(function($){
  var library_nav = $('.library_nav'),
      lib_nav_a = library_nav.find('.nav_item'),
      detail_wrap = $('.detail_wrap'),
      ingrs_details = $('.ingredients_detail');

  if ( library_nav.length > 0 ) {
    lib_nav_a.click(function(e){
      e.preventDefault();
  
      var target = $(this).data('target'),
          target_elem = $('#' + target),
          scroll_cont = detail_wrap.scrollTop();
  
      detail_wrap.animate({
        scrollTop: target_elem.position().top + scroll_cont
      });
    });
  
    detail_wrap.on("scroll", function () {
      var container = $(this);
      var containerHeight = container.height();
      var scrollTop = container.scrollTop();
  
      var visibleSections = [];
  
      container.find(ingrs_details).each(function () {
          var section = $(this);
          var sectionTop = section.position().top;
          var sectionBottom = sectionTop + section.outerHeight();
  
          if (sectionBottom > 0 && sectionTop < containerHeight) {
              visibleSections.push({
                  id: section.attr("id"),
                  visibleArea: Math.min(sectionBottom, containerHeight) - Math.max(sectionTop, 0)
              });
          }
      });
  
      if (visibleSections.length > 0) {
          visibleSections.sort((a, b) => b.visibleArea - a.visibleArea);
  
          var mostVisibleSection = visibleSections[0].id;
  
          lib_nav_a.removeClass("active_nav");
  
          lib_nav_a.each(function(){
            var this_target = $(this).data('target');
            if ( this_target == mostVisibleSection ) {
              $(this).addClass("active_nav")
            }
          });
      }
    });
    detail_wrap.trigger("scroll");
  
    var ingr_label = ingrs_details.find('.ingredient_label'),
        ingr_content = ingrs_details.find('.ingredient_content');
  
    ingr_label.click(function(){
      var this_par = $(this).parent(),
          this_content = $(this).siblings('.ingredient_content');

      if ( this_par.hasClass('active') ) {
        this_par.removeClass('active');
        
        toggle_ingr_content(this_content, 'slideUp', 'clicked');
      } else {
        ingrs_details.not(this_par).removeClass('active');
        toggle_ingr_content(ingr_content.not(this_content), 'slideUp', 'clicked');
  
        this_par.addClass('active');
        toggle_ingr_content(this_content, 'slideDown', 'clicked');
      }
      
    });

    function handleMobileIngredients() {
      if (window.innerWidth <= 767) {
        ingrs_details.each(function(){
          if ($(this).hasClass('active')) {
            var this_content = $(this).find('.ingredient_content');
            toggle_ingr_content(this_content, 'slideDown');
          }
        });
      }
    }

    handleMobileIngredients();

    $(window).on('resize', handleMobileIngredients);

    function toggle_ingr_content(target_elem, slide_action, action_type){
      var parent_elem = target_elem.parent(),
          header_height = $('.header').height();

      if ( slide_action == 'slideUp' ) {
        target_elem.slideUp();
      } else {
        if ( action_type == 'clicked' ) {
          target_elem.slideDown(400, function() {
            var scroll_cont = parent_elem[0].offsetTop - header_height;
            $('html, body').animate({
              scrollTop: scroll_cont
            }, 600);
          });
        } else {
          target_elem.slideDown();
        }
      }
    }
  }

  var img_slide = $('.image_slides');
  if ( img_slide.length > 0 ) {
    var img_swiper = new Swiper(".image_slides .swiper-container", {
      slidesPerView: "auto",
      spaceBetween: 8,
      freeMode: true,
      breakpoints: {
        768: {
          spaceBetween: 16,
        },
        1024: {
          freeMode: false
        }
      }
    });
  }

  $('.product__accordion summary').on('click',function(){
    var this_par = $('.product__accordion'),
        this_par_sib = this_par.siblings('.product__accordion');

    accordion_add_function(this_par, this_par_sib);
  });

  $('.product-content__accordion summary').on('click',function(){
    var this_par = $('.product-content__accordion'),
        this_par_sib = this_par.siblings('.product-content__accordion');

    accordion_add_function(this_par, this_par_sib);
  });

  function accordion_add_function($parents, $par_sib){
    var this_par = $parents,
        this_par_sib = $par_sib,
        sib_details = this_par_sib.find('details'),
        sib_btn = sib_details.find('summary');

    sib_details.removeAttr('open');
    sib_btn.attr('aria-expanded', false);
  }

  if ( $('.slide_col .swiper-container').length > 0 ) {
    var swiper_slide_col = new Swiper(".slide_col .swiper-container", {
      pagination: {
        el: ".slide_col .pagination",
        clickable: true
      },
    });
  }

  var faq_accordion = $('.faq_accordion'),
      faq_item = faq_accordion.find('.accordion_item'),
      faq_content = faq_item.find('.content');
  if ( faq_accordion.length > 0 ) {
    faq_item.click(function(){
      var $this = $(this),
          this_content = $this.find('.content');

      if ( $this.hasClass('active') ) {
        $this.removeClass('active');
        this_content.slideUp();
      } else {
        faq_item.not($this).removeClass('active');
        faq_content.not(this_content).slideUp();

        $this.addClass('active');
        this_content.slideDown();
      }
    });
  }

  // let mob_scroll_container = $(".image-with-text-v3 .mobile-scroll-container"); 
  let mob_scroll_container = $(".image-with-text-v3 .mobile-scroll-container .mobile-scroll-container-inner"); // Your scrollable container

  if ( mob_scroll_container.length > 0 ) {
    mob_scroll_container.each(function(){
      let mob_scroll_items = $(this).find(".media-item");

      console.log("Total Items:", mob_scroll_items.length);
      mob_scroll_container.on("scroll", function () {
        requestAnimationFrame(updateActiveItem);
      });

      function updateActiveItem() {
        let containerRect = mob_scroll_container[0].getBoundingClientRect();
        let closestItem = null;
        let closestDistance = Infinity;

        mob_scroll_items.each(function () {
          let itemRect = this.getBoundingClientRect();
          let distance = Math.abs(itemRect.left - containerRect.left);

          // Find the item closest to the left edge of the container
          if (distance < closestDistance) {
            closestDistance = distance;
            closestItem = $(this);
          }
        });

        // Remove previous active class and add to the closest item
        if (closestItem) {
          mob_scroll_items.not(closestItem).removeClass("active");
          closestItem.addClass("active");
        }
      }updateActiveItem();
    });
  }

  var prod_accordion = $('.product__accordion, .product-content__accordion'),
      prod_accord_content = prod_accordion.find('.accordion__content');
  if ( prod_accordion.length > 0 ) {
    // Handle active accordions on page load
    prod_accordion.each(function() {
      if ($(this).hasClass('active')) {
        $(this).find('.accordion__content').slideDown();
      }
    });

    prod_accordion.click(function(){
      var $this_par = $(this),
          this_siblings = $this_par.siblings('.product__accordion, .product-content__accordion'),
          this_content = $this_par.find('.accordion__content');

      if ( $this_par.hasClass('active') ) {
        $this_par.removeClass('active');
        this_content.slideUp();
      } else {
        this_siblings.removeClass('active');
        this_siblings.find('.accordion__content').slideUp();

        $this_par.addClass('active');
        this_content.slideDown();
      }
    });
  }
});